(function() {
  var ContactsHandler, ScrollHelper,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ContactsHandler = App.loadClass("grower::handlers/contacts/Contacts_Handler");

  ScrollHelper = App.load("core::ScrollHelper");

  exports.Invite_Tab_Handler = (function(superClass) {
    extend(Invite_Tab_Handler, superClass);

    function Invite_Tab_Handler() {
      return Invite_Tab_Handler.__super__.constructor.apply(this, arguments);
    }

    Invite_Tab_Handler.prototype.init = function() {
      var msgwriter;
      this.layoutUrl = "backend/grower/contacts/invitetab/load-layout";
      this.layoutSelector = "#contactstab_invite";
      msgwriter = App.sidebar.messageWriter();
      msgwriter.message_writer();
      msgwriter.message_writer('info', 'Loading...');
      return this.loadLayout();
    };

    Invite_Tab_Handler.prototype.afterLoadLayout = function(selector, data) {
      var laySel, ths;
      ths = this;
      laySel = this.layoutSelector;
      $(laySel).find('.txt-search').focus();

      /*
          Can I change the layoutUrl dynamically and so change which views, etc are being used and stuff thus making better code?
       */
      $(this.layoutSelector).find('.txt-search').keypress(function(event) {
        if (event.which === 13) {
          return $(laySel).find('.btn-search').click();
        }
      });
      $(this.layoutSelector).find('.btn-search').click(function(e) {
        var search, tableDiv;
        search = $(laySel).find('.txt-search');
        if (search.val()) {
          tableDiv = $(laySel).find('.table-div');
          tableDiv.removeClass('example');
          tableDiv.empty().append("<text class='saving'>Searching...</text>");
          return $.post('backend/grower/contacts/invitetab/get-searchresults-ajax', {
            'search_text': search.val()
          }, function(json) {
            if (json.status.type === 'success') {
              tableDiv.empty().append(json.data);
              $('.blocked-user').tooltip(true, 'top', false, 'Blocked User', 'hover', 0);
              $(tableDiv).find('.sel-permission').change({
                'ths': ths
              }, ths.permissionListener);
              return ths.pgSetup(selector);
            } else {
              return App.current_page.refreshSubHandlers();
            }
          });
        } else {
          if (!$(laySel).find('.example-table-div').length > 0) {
            return App.current_page.refreshSubHandlers();
          }
        }
      });
      return this.tabLoadLayoutCallback(selector, data);
    };

    Invite_Tab_Handler.prototype.pgSetup = function(selector, data) {
      var table, ths;
      ths = this;
      $(this.layoutSelector).find('#addpermission').click(function(e) {
        var handler, sub;
        e.preventDefault();
        handler = $(this).data('handler');
        sub = ths.createSubHandler(handler);
        if (sub) {
          return sub.init();
        }
      });
      $(this.layoutSelector).find('#editpermission').click(function(e) {
        var handler, sub;
        e.preventDefault();
        handler = $(this).data('handler');
        sub = ths.createSubHandler(handler);
        if (sub) {
          return sub.init();
        }
      });
      $(this.layoutSelector).find('#removepermission').click(function(e) {
        var handler, sub;
        e.preventDefault();
        handler = $(this).data('handler');
        sub = ths.createSubHandler(handler);
        if (sub) {
          return sub.init();
        }
      });
      App.sidebar.contentDiv().find(".tab-content").resizr();
      table = $(selector).find(".list-table");
      $(selector).find(".table-container").resizr();
      ScrollHelper.make(table, {
        height: $(selector).find(".table-container").resizr('size')
      });
      return table.find('tbody tr .row-clickable').bind('click', function(e) {
        table.find('tr').removeClass('darken');
        return ths.viewUserS(e, $(this), selector);
      });
    };

    Invite_Tab_Handler.prototype.permissionListener = function(event) {
      var contact_id, original, permission_id, requestVars, sel, ths, tr, undoVars;
      ths = event.data.ths;
      sel = $(this);
      tr = sel.parents('tr');
      original = tr.html();
      contact_id = sel.data('contact_id');
      permission_id = sel.val();
      sel.replaceWith('<text class="saving">Saving...</text>');
      if (sel.data('blocked')) {
        requestVars = {
          'contact_id': contact_id,
          'permission_id': permission_id,
          'blocked': true
        };
        undoVars = {
          'tr': tr,
          'original': original,
          'ths': ths,
          'blocked': true
        };
      } else {
        requestVars = {
          'contact_id': contact_id,
          'permission_id': permission_id
        };
        undoVars = {
          'tr': tr,
          'original': original,
          'ths': ths,
          'blocked': false
        };
      }
      return $.post('backend/grower/contacts/invitetab/requestcontact-ajax', requestVars, function(json) {
        var confirmed, undo;
        if (json.status.type === 'success') {
          tr.tooltip('disable');
          confirmed = "<text class='contact_success'>Request Sent!</text>";
          undo = "<a class='a-undo' data-contact_id=" + contact_id + " data-permission_id=" + permission_id + ">(Undo)</a>";
          tr.empty().append("<td colspan='3'> " + confirmed + " &nbsp;&nbsp;&nbsp;&nbsp; " + undo + " </td>");
          return tr.find('.a-undo').bind("click", undoVars, ths.undoListener);
        } else {
          return App.current_page.refreshSubHandlers();
        }
      });
    };

    Invite_Tab_Handler.prototype.undoListener = function(event) {
      var a, blocked, contact_id, original, permission_id, ths, tr, undoVars;
      ths = event.data.ths;
      tr = event.data.tr;
      original = event.data.original;
      blocked = event.data.blocked;
      event.preventDefault();
      a = $(this);
      contact_id = a.data('contact_id');
      permission_id = a.data('permission_id');
      if (blocked) {
        undoVars = {
          'contact_id': contact_id,
          'permission_id': permission_id,
          'blocked': true
        };
      } else {
        undoVars = {
          'contact_id': contact_id,
          'permission_id': permission_id
        };
      }
      return $.post('backend/grower/contacts/invitetab/undorequest-ajax', undoVars, function(json) {
        if (json.status.type === 'success') {
          tr.empty().append(original);
          return tr.find('.sel-permission').bind("change", {
            'ths': ths
          }, ths.permissionListener);
        } else {
          return App.current_page.refreshSubHandlers();
        }
      });
    };

    return Invite_Tab_Handler;

  })(ContactsHandler);

}).call(this);
